import { Helmet } from 'react-helmet-async';
import "./Priests.css"
import PriestHeader from "./components/PriestHeader/PriestHeader.js";
import Spotify from "./components/Spotify/Spotify.js";
import { priests, about } from "../../data/priestsData.js";

export default function Priests() {
  const getPriestsList = () => {
    const priestsNames = priests.map(priest => priest.name).join(', ');
    return priestsNames;
  };

  const getMetaDescription = () => {
    const priestsList = getPriestsList();
    const priestCount = priests.length;
    
    const proboszcz = priests.find(priest => priest.role === "Proboszcz");
    const wikariusze = priests.filter(priest => priest.role === "Wikariusz");
    
    let description = `Duszpasterze parafii św. Urszuli Ledóchowskiej w Częstochowie: ks. Mikołaj Węgrzyn, ks. Błażej Małolepszy, ks. Jan Fronczak oraz ks. Marek Madej. Wspólnota parafialna na Wrzosowiaku. Zapraszamy na msze święte i do kontaktu z duszpasterzami.`;
    
    if (proboszcz) {
      description += `Proboszcz: ${proboszcz.name}. `;
    }
    
    if (wikariusze.length > 0) {
      description += `Wikariusze: ${wikariusze.map(w => w.name).join(', ')}. `;
    }
    
    description += `Wspólnota parafialna na Wrzosowiaku. Zapraszamy na msze święte i do kontaktu z duszpasterzami.`;
    
    return description;
  };

  const getKeywords = () => {
    const roles = [...new Set(priests.map(priest => priest.role).filter(Boolean))];
    const names = priests.map(priest => priest.name.split(' ')[1]).filter(Boolean);
    return `duszpasterze, księża, ${roles.join(', ')}, ${names.join(', ')}, parafia Częstochowa, św. Urszula Ledóchowska, Wrzosowiak`;
  };

  const firstWithoutRoleIndex = priests.findIndex(priest => !priest.role);

  const scrollToPriest = (priestId) => {
    const element = document.getElementById(priestId);
    if (element) {
      const isMobile = window.innerWidth <= 768;
      
      if (isMobile) {
        element.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start'
        });
      } else {
        const contentContainer = element.closest('.content');
        if (contentContainer) {
          const elementRect = element.getBoundingClientRect();
          const containerRect = contentContainer.getBoundingClientRect();
          const offset = elementRect.top - containerRect.top + contentContainer.scrollTop - 20;
          
          contentContainer.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        } else {
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        }
      }
    }
  };

  const generatePriestLinks = () => {
    const allPriests = [
      ...priests.map((p, idx) => ({ ...p, isLink: true, index: idx })),
      { name: 'Marek Madej', isLink: false, index: priests.length }
    ];

    return allPriests.map((priest, idx) => {
      if (priest.isLink) {
        const priestId = `priest-${priest.index}`;
        let displayName = priest.onlyName;
        if (!priest.onlyName.startsWith('ks.')) {
          displayName = `ks. ${priest.onlyName}`;
        }
        
        return (
          <a 
            key={idx}
            href={`#${priestId}`}
            onClick={(e) => {
              e.preventDefault();
              scrollToPriest(priestId);
            }}
            className="priest-link"
          >
            {displayName}
          </a>
        );
      } else {
        return (
          <span key={idx} className="priest-name-only">
            ks. {priest.name}
          </span>
        );
      }
    });
  };

  return (
    <>
      <Helmet>
        <title>Duszpasterze – Parafia św. Urszuli Ledóchowskiej w Częstochowie</title>
        <meta name="description" content={getMetaDescription()} />
        <meta name="keywords" content={getKeywords()} />
        <meta property="og:title" content="Duszpasterze – Parafia św. Urszuli Ledóchowskiej" />
        <meta property="og:description" content={`Duszpasterze parafii św. Urszuli Ledóchowskiej: ${getPriestsList()}. Proboszcz i wikariusze zapraszają na msze święte i do sakramentów.`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://swurszula.pl/duszpasterze" />
        <meta property="og:locale" content="pl_PL" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Duszpasterze – Parafia św. Urszuli Ledóchowskiej" />
        <meta name="twitter:description" content={`Księża pracujący w parafii św. Urszuli Ledóchowskiej: ${getPriestsList()}. Sprawdź ich posługę i duszpasterstwo.`} />
      </Helmet>

      <div>
        <p className="priests-about">
          W naszej Parafii posługę duszpasterską pełnią: {generatePriestLinks()}
        </p>
        
        {priests.map((priest, index) => {
          const priestId = `priest-${index}`;
          return (
            <div key={index} id={priestId} className="priest-item">
              {index === firstWithoutRoleIndex && (
                <h3 className="section-subtitle">Mieszkają w parafii: </h3>
              )}
              <PriestHeader priest={priest} />
              <div className="description-priest">
                {priest.description}
                {priest.page && (
                  <Spotify label={priest.pageLabel} url={priest.page} />
                )}
                {priest.quote && ((<i>{priest.quote}</i>))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}